// extracted by mini-css-extract-plugin
export var container = "AskInput-module--container--V+IDn";
export var first = "AskInput-module--first--dJzMm";
export var img = "AskInput-module--img--dN-bN";
export var input = "AskInput-module--input--qM7xu";